import { Service } from './model'

export const isMgService = (service: string): boolean => service === Service.MG

export const isUloztoService = (service: string): boolean => service === Service.Ulozto
